import {
  container,
  cardTitle,
  whiteColor,
  grayColor
} from "assets/jss/default/theme.js";

const loginPageStyle = theme => ({
  container: {
    ...container,
    zIndex: "4",
    [theme.breakpoints.down("md")]: {
      paddingBottom: "100px"
    }
  },
  cardTitle: {
    ...cardTitle,
    color: whiteColor
  },
  textCenter: {
    textAlign: "center"
  },
  justifyContentCenter: {
    justifyContent: "center !important"
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: whiteColor
    },
    marginLeft: "5px",
    marginRight: "5px"
  },
  inputAdornment: {
    marginRight: "18px"
  },
  inputAdornmentIcon: {
    color: grayColor[6]
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  cardHeader: {
    marginBottom: "20px"
  },
  logo: {
    paddingTop: "30px",
    width: "80%"
  },
  button: {
    whiteSpace: "normal"
  },
  socialLine: {
    padding: "0.9375rem 0"
  },
  buttonProgress: {
    color: whiteColor,
    position: "absolute",
    top: "44.5%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
    width: "100%"
  }
});

export default loginPageStyle;
